// /auto_payment_contract_settings/save/{district_id}
import { Request } from '@/classes/Request.ts'

export const saveAutoPayContractSettings = async (
  districtId: TDistrictId,
  payload: Object
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/auto_payment_contract_settings/save/${districtId}`, payload)
      .then(result => {
        resolve(result.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
